module.exports = __webpack_public_path__ + "static/img/car.3a0422c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/car.jpg
// module id = 204
// module chunks = 1